import React, { useEffect, useRef, useState } from "react";
import { Box, Typography, Container, Grid, useMediaQuery } from "@mui/material";
import { gsap } from "gsap";
import { aboutus1, aboutus2, aboutus3, gardientline, line } from "../../assets";

const AboutUsSection = () => {
  const textRef = useRef(null);
  const isMobile = useMediaQuery("(max-width: 600px)");
  const [activeIndex, setActiveIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const hoverTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const isHoveredRef = useRef(false);

  useEffect(() => {
    const interval = setInterval(() => {
      if (!isPaused) {
        setActiveIndex((prev) => (prev + 1) % 3);
      }
    }, 5000);

    return () => clearInterval(interval);
  }, [isPaused]);

  useEffect(() => {
    if (textRef.current) {
      gsap.fromTo(
        textRef.current,
        { opacity: 0, y: 30 },
        { opacity: 1, y: 0, duration: 1, ease: "power2.out" }
      );
    }
  }, []);

  const images = [
    aboutus1,
    aboutus2,
    aboutus3,
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      if (!isPaused && !isHoveredRef.current) {
        setActiveIndex((prev) => (prev + 1) % images.length);
      }
    }, 5000);

    return () => clearInterval(interval);
  }, [isPaused]);

  useEffect(() => {
    gsap.fromTo(
      ".image-box",
      { opacity: 0, scale: 0.8 },
      { opacity: 1, scale: 1, duration: 0.8, ease: "power2.out" }
    );
  }, [activeIndex]);

  const handleMouseEnter = (index: number) => {
    isHoveredRef.current = true;
    clearTimeout(hoverTimeoutRef.current!);
    setIsPaused(true);
    setActiveIndex(index);
  };

  const handleMouseLeave = () => {
    hoverTimeoutRef.current = setTimeout(() => {
      isHoveredRef.current = false;
      setIsPaused(false);
    }, 500);
  };

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: "auto",
        backgroundColor: "#000",
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        px: { xs: 1, md: 4 },
        py: { xs: 3, md: 4 },
      }}
    >
      <Box
        sx={{
          width: "100%",
          color: "white",
          py: { xs: 1, md: 4 },
          px: { xs: 1, md: 2 },
        }}
      >
        <Container maxWidth="xl">
          <Box sx={{ textAlign: "left", mb: 1 }}>
            <Typography
              variant="h3"
              sx={{
                fontWeight: "600",
                fontSize: "28px",
                background: "linear-gradient(90deg, #bf742c,rgb(252, 243, 202), #c58038)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                display: "inline-block",
                fontFamily: "LEMON MILK",
                mb: 4,
              }}
            >
              About Us
            </Typography>
            {/* <Box sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center", my: 1, width: "100%", mb: 4 }}>
              <img src={gardientline} alt="Gradient Line" style={{ width: "100%", maxWidth: "900px", marginLeft: "-100px" }} />
            </Box> */}
          </Box>

          <Container maxWidth="xl">

          <Box sx={{ textAlign: "center", mb: 4, ml: 4 }}>
            <span
              style={{
                fontSize: "14px",
                marginBottom: "20px",
                textAlign: "center",
                fontWeight: "300",
                fontFamily: "LEMON MILK",
                letterSpacing: "0.8px",
                color: 'rgba(180, 180, 180, 0.8)',
                display: "block",
                margin: "0 auto",
              }}
              ref={textRef}
            >
              At Kolla Group, we take pride in creating luxury real estate assets that stand the test of time. For us, luxury is defined by an unwavering commitment to superior craftsmanship, meticulous attention to detail, and the highest standards of quality. With a legacy built on trust and excellence, we have established ourselves as a distinguished name in the industry, consistently delivering landmark residential projects in prime locations.
            </span>
          </Box>

          <Box sx={{ textAlign: "center", mb: 0, ml: 4 }}>
            <span
              style={{
                fontSize: "14px",
                marginBottom: "20px",
                textAlign: "center",
                fontWeight: "300",
                fontFamily: "LEMON MILK",
                letterSpacing: "0.8px",
                color: 'rgba(180, 180, 180, 0.8)',
                display: "block",
                margin: "0 auto",
              }}
            >
              With over three decades of expertise, we have successfully developed more than 4 million square feet of land, with an additional 4 million square feet in progress. Our legacy is reflected in the trust of 1,000+ happy families who have chosen to make our communities their home.
            </span>
          </Box>
          </Container>


        </Container>
      </Box>
    </Box>
  );
};

export default AboutUsSection;
